var _defs, _rect, _rect2, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect3, _rect4, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _polygon2, _polygon3, _path36, _path37, _polygon4, _polygon5, _path38, _path39;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilesAndFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 823.97,
    height: 568.97,
    viewBox: "0 0 823.97 568.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 392.82,
    y1: 442.3,
    x2: 740.1,
    y2: -71.64,
    gradientTransform: "translate(-0.03 -200)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fff",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#fff",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fff",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 687.85,
    y1: -26.62,
    x2: 306.77,
    y2: 540.93,
    gradientTransform: "translate(-0.03 -200)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 691.62,
    y1: 469.69,
    x2: -175.43,
    y2: 489.5,
    gradientTransform: "translate(-0.03 -209.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 432.37,
    y1: 25.45,
    x2: 258.93,
    y2: 439.9,
    gradientTransform: "matrix(1, 0, 0, -1, -0.03, 570)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 333.4,
    y1: 218.47,
    x2: 326.41,
    y2: 477.18,
    gradientTransform: "translate(-0.03 -209.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 298.42,
    y1: 337.63,
    x2: 231.55,
    y2: 342.58,
    gradientTransform: "translate(-0.03 -209.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 328.71,
    y1: 337.63,
    x2: 261.84,
    y2: 342.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 359,
    y1: 337.63,
    x2: 292.13,
    y2: 342.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 389.29,
    y1: 337.63,
    x2: 322.42,
    y2: 342.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 419.58,
    y1: 337.63,
    x2: 352.71,
    y2: 342.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 449.87,
    y1: 337.63,
    x2: 383,
    y2: 342.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 480.16,
    y1: 337.63,
    x2: 413.29,
    y2: 342.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 510.45,
    y1: 337.63,
    x2: 443.58,
    y2: 342.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 604.94,
    y1: 478.59,
    x2: 604.25,
    y2: 424.01,
    gradientTransform: "translate(-0.03 -209.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 661.08,
    y1: 333.03,
    x2: 716.14,
    y2: 333.03,
    gradientTransform: "translate(-0.03 -209.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 674.06,
    y1: 517.96,
    x2: 676.9,
    y2: 370.44,
    gradientTransform: "translate(-0.03 -209.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 685.87,
    y1: 365.23,
    x2: 616.35,
    y2: 804.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 673.54,
    y1: 308.77,
    x2: 726.92,
    y2: 308.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 556.73,
    y1: 169.35,
    x2: 574.47,
    y2: 269.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 554.38,
    y1: 428.89,
    x2: 556.07,
    y2: -91.44,
    gradientTransform: "matrix(1, 0, 0, -1, -0.03, 570)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 584.76,
    y1: 402.53,
    x2: 586.45,
    y2: -117.8,
    gradientTransform: "matrix(1, 0, 0, -1, -0.03, 570)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 615.05,
    y1: 402.62,
    x2: 616.74,
    y2: -117.7,
    gradientTransform: "matrix(1, 0, 0, -1, -0.03, 570)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 645.34,
    y1: 402.72,
    x2: 647.03,
    y2: -117.6,
    gradientTransform: "matrix(1, 0, 0, -1, -0.03, 570)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 675.62,
    y1: 402.82,
    x2: 677.31,
    y2: -117.5,
    gradientTransform: "matrix(1, 0, 0, -1, -0.03, 570)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 705.91,
    y1: 402.92,
    x2: 707.59,
    y2: -117.4,
    gradientTransform: "matrix(1, 0, 0, -1, -0.03, 570)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 736.2,
    y1: 403.02,
    x2: 737.88,
    y2: -117.31,
    gradientTransform: "matrix(1, 0, 0, -1, -0.03, 570)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 766.49,
    y1: 403.12,
    x2: 768.18,
    y2: -117.21,
    gradientTransform: "matrix(1, 0, 0, -1, -0.03, 570)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 553,
    y1: 458.91,
    x2: 582.74,
    y2: 458.91,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 670.22,
    y1: 570.88,
    x2: 697.88,
    y2: 570.88,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 702.47,
    y1: 301.87,
    x2: 688.76,
    y2: 350.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 637.38,
    y1: 614.68,
    x2: 556.2,
    y2: 867.34,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 677.53,
    y1: 599.83,
    x2: 737.47,
    y2: 869.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 576.58,
    y1: 690.86,
    x2: 581.13,
    y2: 885.1,
    gradientTransform: "translate(-0.03 -209.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 706.39,
    y1: 687.82,
    x2: 710.94,
    y2: 882.06,
    gradientTransform: "translate(-0.03 -209.57)",
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_folder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.35,480.22c-2.06,1.71-4.21,3.56-5,6.11-1.34,4.17,1.37,8.52,4.36,11.72C20.2,514.64,44.66,518.52,67.23,521A1548.84,1548.84,0,0,0,374,523.52a17.82,17.82,0,0,0-2.33,2.09c-13.64,14.36-4,38.24,15.8,39.76,126.64,9.75,254.32-2.1,381-14,10.15-1,18.27-19.12,26.73-24.81s13.68-17.55,8.63-26.39c-6.73-11.77-26.57-11.65-31.47-24.29-4.82-12.43,8.95-23.65,13.58-36.14,6.09-16.44-5.3-35.21-20.77-43.43s-33.79-8.53-51.32-8.58a5874.85,5874.85,0,0,0-592,28.15c-23,2.25-38.72,2.55-57.16,14.92C43.7,444.88,24.75,464.08,5.35,480.22Z",
    transform: "translate(0)",
    fill: "#2c7be5",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.55,550.43c4.36-.87,9.14-1.75,13.06.35,2,1.07,3.58,2.83,5.66,3.71,3.85,1.63,8.19-.09,12.23-1.17,15.35-4.11,31.45,1.5,47.32,2.24,15.07.71,30-3,44.59-6.69,3.81-1,8.52-3.1,8.19-7-.48-5.6-9.82-5-12.91-9.67l26.61-14c3-1.55,6.14-3.36,7.27-6.49,1.32-3.67-.86-7.88-4.13-10s-7.31-2.59-11.21-2.69c-18.27-.45-35.92,5.91-53.8,9.76a199.29,199.29,0,0,1-62.81,3.37c-4.83-.52-9.72-1.2-14.49-.37-12.11,2.12-22.19,12.55-32.71,18.32-8.51,4.67-17.52,8.32-26.53,11.89-10,4-29.22,7.52-35.9,16.29,9.07,4.16,24.12.64,33.9-.13A476.58,476.58,0,0,0,621.55,550.43Z",
    transform: "translate(0)",
    fill: "#2c7be5",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 260.83,
    width: 409.78,
    height: 268.74,
    fill: "#2c7be5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 260.83,
    width: 409.78,
    height: 268.74,
    fill: "url(#linear-gradient)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "260.83 52.86 567.85 52.86 607.55 249.38 258.46 94.65 260.83 52.86",
    fill: "url(#linear-gradient-2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M574.75,185.13V410.91a18,18,0,0,1-18,18H71.88a18,18,0,0,1-18-18V126.56a18,18,0,0,1,18-18H199.15a20.44,20.44,0,0,1,20.38,18.87l1.29,17a24.6,24.6,0,0,0,24.53,22.72H556.78a18,18,0,0,1,17.71,14.92A18.41,18.41,0,0,1,574.75,185.13Z",
    transform: "translate(0)",
    fill: "#2c7be5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M574.75,185.13V410.91a18,18,0,0,1-18,18H71.88a18,18,0,0,1-18-18V126.56a18,18,0,0,1,18-18H199.15a20.44,20.44,0,0,1,20.38,18.87l1.29,17a24.6,24.6,0,0,0,24.53,22.72H556.78a18,18,0,0,1,17.71,14.92A18.41,18.41,0,0,1,574.75,185.13Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54,410.91V126.56",
    transform: "translate(0)",
    fill: "#2c7be5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M252.43,167.15h-7.08a24.6,24.6,0,0,1-24.53-22.72l-1.29-17a20.2,20.2,0,0,0-.7-4h10a20.43,20.43,0,0,1,20.38,18.87l1.3,17A24.43,24.43,0,0,0,252.43,167.15Z",
    transform: "translate(0)",
    fill: "#222a72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M574.75,185.13V410.91a18,18,0,0,1-18,18H83.87a18.38,18.38,0,0,1-.26-3.05V141.43a18,18,0,0,1,18-18H218.83a20.2,20.2,0,0,1,.7,4l1.29,17a24.6,24.6,0,0,0,24.53,22.72h7.08a24.63,24.63,0,0,0,22.62,14.92H574.49A18.41,18.41,0,0,1,574.75,185.13Z",
    transform: "translate(0)",
    fill: "#2c7be5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M574.75,177.68V403.43a18,18,0,0,1-18,18H83.87a18.38,18.38,0,0,1-.26-3.05V134a18,18,0,0,1,18-18H218.83a21,21,0,0,1,.7,4l1.29,17a24.61,24.61,0,0,0,24.53,22.73h7.08a24.63,24.63,0,0,0,22.62,14.92H574.49A18.05,18.05,0,0,1,574.75,177.68Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M549.53,59.16v108H245.35a24.61,24.61,0,0,1-24.53-22.73l-1.29-17a20.43,20.43,0,0,0-20.38-18.87H111.58V59.16Z",
    transform: "translate(0)",
    fill: "#2c7be5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M549.53,59.16v108H245.35a24.61,24.61,0,0,1-24.53-22.73l-1.29-17a20.43,20.43,0,0,0-20.38-18.87H111.58V59.16Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-5)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M258.71,98.19v69h-6.28v-69a3.13,3.13,0,0,1,3.12-3.14h0a3.11,3.11,0,0,1,3.14,3.08h0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-6)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M289,98.19v69h-6.28v-69a3.14,3.14,0,0,1,6.28,0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-7)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M319.29,98.19v69H313v-69a3.14,3.14,0,0,1,6.28,0h0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-8)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M349.58,98.19v69H343.3v-69a3.13,3.13,0,0,1,3.12-3.14h0a3.22,3.22,0,0,1,2.23.91A3.16,3.16,0,0,1,349.58,98.19Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-9)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M379.87,98.19v69h-6.28v-69a3.14,3.14,0,1,1,6.28,0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-10)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M410.16,98.19v69h-6.28v-69A3.12,3.12,0,0,1,407,95.05h0a3.22,3.22,0,0,1,2.23.91A3.14,3.14,0,0,1,410.16,98.19Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-11)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M440.45,98.19v69h-6.28v-69a3.14,3.14,0,1,1,6.28,0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-12)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M470.74,98.19v69h-6.28v-69a3.14,3.14,0,1,1,6.28,0Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-13)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M613,234.88c-3.48,1.92-7.08,3.79-11,4.39-10,1.53-19.59-5.52-29.76-5.58A22.51,22.51,0,0,0,552,246.86c9.27,1.69,18.78,1.38,28.2,1.07l52.16-1.75c3.81-.13,8.09-.47,10.55-3.37,1.56-1.83,2-4.31,3-6.5,1.68-3.69,4.79-6.51,7-9.92,2.45-3.79,5-10.8,3.41-15.37-2.25-6.3-8.32,1.19-11.72,3.68A290.55,290.55,0,0,1,613,234.88Z",
    transform: "translate(0)",
    fill: "#2c7be5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M613,234.88c-3.48,1.92-7.08,3.79-11,4.39-10,1.53-19.59-5.52-29.76-5.58A22.51,22.51,0,0,0,552,246.86c9.27,1.69,18.78,1.38,28.2,1.07l52.16-1.75c3.81-.13,8.09-.47,10.55-3.37,1.56-1.83,2-4.31,3-6.5,1.68-3.69,4.79-6.51,7-9.92,2.45-3.79,5-10.8,3.41-15.37-2.25-6.3-8.32,1.19-11.72,3.68A290.55,290.55,0,0,1,613,234.88Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-14)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M661.05,118.11c0,2.86,2,5.34,2.55,8.14.77,3.69-.91,7.83.9,11.13,2,3.68,7,4.07,10.89,5.72a15.6,15.6,0,0,1,9.1,15.75,3.33,3.33,0,0,0,.22,2.3,3,3,0,0,0,2.25.93l9.74,1a5.88,5.88,0,0,0,3.37-.31,5.22,5.22,0,0,0,2.06-2.72c2.81-6.74,2.3-14.37,4-21.48,2.18-9.42,8.09-17.75,9.61-27.3a31,31,0,0,0-2.5-17.79c-1.6-3.44-4-6.7-7.45-8.27a20.93,20.93,0,0,0-7.7-1.41c-9.89-.48-23.49.68-26.22,12.45-.91,4-.28,7.12-2.89,10.64S661.08,113.1,661.05,118.11Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-15)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M667.32,78.22c-.83,6.15,4.18,11.45,9.12,15.19s21.3,11.49,22.35,16.29.72,9.78.38,14.68c.72,3,5.43-5.62,6.35-5.94,3.52-2.4,4.49,1.18,4.78,2.48a6,6,0,0,1-.54,3.74c-1.47,3.61-7.53,12.31-5.74,18.89,5.41,1,7.05-12.6,12-14.9,7-3.23,13-6.42,15-13.85,2.35-8.81,4.36-18.64.08-26.7a10.21,10.21,0,0,0-2.68-3.37c-1-.75-2.15-1.22-3.19-1.88-2.83-1.77-4.61-4.76-6.71-7.35a33.86,33.86,0,0,0-19.89-11.9c-6.6-1.24-14.7-.66-20.64,2.75C673.71,68.81,668,73.07,667.32,78.22Z",
    transform: "translate(0)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M717.66,269.76a151.49,151.49,0,0,0,6.4-14.88c7.06-20.22,5.32-42.32,3.17-63.63a45.58,45.58,0,0,0-1.65-9.55,43.18,43.18,0,0,0-5.4-10.26q-4.68-7.12-9.8-14c-.87-1.16-1.86-2.39-3.27-2.73a6.36,6.36,0,0,0-3,.27l-8.22,2.09c-7.34,1.87-15.3,4.15-19.66,10.35-13.39,19-25.16,40.76-32.49,62.84q-10,30.19-20,60.39c-2.62,7.88-5.09,17.05-.59,24,5.31,8.2,17,8.56,26.72,8l17.3-1c7.28-.41,15.32-1.15,20.36-6.42a29.23,29.23,0,0,0,3.94-5.74C700.37,294,710,286,717.66,269.76Z",
    transform: "translate(0)",
    fill: "#2c7be5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M717.66,269.76a151.49,151.49,0,0,0,6.4-14.88c7.06-20.22,5.32-42.32,3.17-63.63a45.58,45.58,0,0,0-1.65-9.55,43.18,43.18,0,0,0-5.4-10.26q-4.68-7.12-9.8-14c-.87-1.16-1.86-2.39-3.27-2.73a6.36,6.36,0,0,0-3,.27l-8.22,2.09c-7.34,1.87-15.3,4.15-19.66,10.35-13.39,19-25.16,40.76-32.49,62.84q-10,30.19-20,60.39c-2.62,7.88-5.09,17.05-.59,24,5.31,8.2,17,8.56,26.72,8l17.3-1c7.28-.41,15.32-1.15,20.36-6.42a29.23,29.23,0,0,0,3.94-5.74C700.37,294,710,286,717.66,269.76Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-16)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 489.76,
    y: 244.8,
    width: 334.21,
    height: 207.42,
    fill: "#2c7be5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 489.76,
    y: 244.8,
    width: 334.21,
    height: 207.42,
    fill: "url(#linear-gradient-17)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M673.72,368.94a11.38,11.38,0,0,0,4.64.46c-.88,2.08,2,3.91,4.27,3.48s4.12-2,6.36-2.23c1.2-.11,2.46.16,3.59-.28a5.38,5.38,0,0,0,2.35-2.21c2.45-3.62,4-7.77,5.44-11.87,3.37-9.34,5.82-19.07,10.12-28,15-31.18,16.65-76.57,16.41-83.67-2.55.08-10.27.34-12.78.79a5.08,5.08,0,0,0-2.35.87,4.78,4.78,0,0,0-1.35,2.27c-2.6,7.5-1.93,15.67-2.75,23.57-1.95,18.92-12.33,35.83-17.54,54.12-2.24,7.87-3.53,16.9-8.87,23.4-1.24,1.51-3.39,3-4.22,4.73-1.11,2.35.49,3.26.36,5.6C677.34,360.88,672.58,368.58,673.72,368.94Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-18)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M561.8,259.43a18.21,18.21,0,0,0,7.88-.67,27.66,27.66,0,0,1,7.83-1.29c2.17.09,4.77.6,6.17-1.06,1.83-2.18-.31-6.06,1.63-8.14.48-.52,1.15-.83,1.63-1.34a1.41,1.41,0,0,0,.22-1.89,1.82,1.82,0,0,0-1.19-.35,179.6,179.6,0,0,0-25.62.44c-2.15.19-4.61.59-5.76,2.43C551.85,251.92,557.73,258.61,561.8,259.43Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-19)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M555,422.3h0a3.16,3.16,0,0,1-3.14-3.14V281.23a3.16,3.16,0,0,1,3.14-3.14h0a3.13,3.13,0,0,1,3.14,3.12h0v138A3.15,3.15,0,0,1,555,422.3Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-20)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M585.32,422.3h0a3.16,3.16,0,0,1-3.14-3.14V281.23a3.16,3.16,0,0,1,3.14-3.14h0a3.13,3.13,0,0,1,3.14,3.12h0v138A3.15,3.15,0,0,1,585.32,422.3Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-21)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M615.61,422.3h0a3.16,3.16,0,0,1-3.14-3.14V281.23a3.16,3.16,0,0,1,3.14-3.14h0a3.13,3.13,0,0,1,3.14,3.12h0v138A3.15,3.15,0,0,1,615.61,422.3Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-22)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M645.9,422.3h0a3.16,3.16,0,0,1-3.14-3.14V281.23a3.16,3.16,0,0,1,3.14-3.14h0a3.13,3.13,0,0,1,3.14,3.12h0v138A3.15,3.15,0,0,1,645.9,422.3Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-23)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M676.19,422.3h0a3.16,3.16,0,0,1-3.14-3.14h0V281.23a3.13,3.13,0,0,1,3.12-3.14h0a3.16,3.16,0,0,1,3.14,3.14h0V419.16A3.16,3.16,0,0,1,676.19,422.3Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-24)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M706.48,422.3h0a3.16,3.16,0,0,1-3.14-3.14h0V281.23a3.13,3.13,0,0,1,3.12-3.14h0a3.16,3.16,0,0,1,3.14,3.14h0V419.16A3.16,3.16,0,0,1,706.48,422.3Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-25)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M736.77,422.3h0a3.16,3.16,0,0,1-3.14-3.14h0V281.23a3.13,3.13,0,0,1,3.12-3.14h0a3.16,3.16,0,0,1,3.14,3.14h0V419.16A3.16,3.16,0,0,1,736.77,422.3Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-26)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M767.06,278.09h0a3.16,3.16,0,0,1,3.14,3.14V419.16a3.16,3.16,0,0,1-3.14,3.14h0a3.16,3.16,0,0,1-3.14-3.14V281.23A3.16,3.16,0,0,1,767.06,278.09Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-27)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M686,229.49q-1.63,41-6.27,81.77c-.61,5.42-1.25,11,.22,16.25.6,2.16,2,8.26,3.43,10,2,2.53,4.43.36,7.63.7,4.77.51,6.55,3.23,9.33-.68s6.83-14.34,8-19a332.91,332.91,0,0,0,7.15-112.28c-.63-5.94-1.47-12-4.18-17.32s-7.67-9.86-13.61-10.53c-9.19-1-14.71,6.75-14,14.8C684.82,205.55,686.47,217,686,229.49Z",
    transform: "translate(0)",
    fill: "#2c7be5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M556.59,242.13a6.26,6.26,0,0,0-2.47,2.12,7.17,7.17,0,0,0-.75,2.83c-.45,3.76-.87,7.77.8,11.17a1.24,1.24,0,0,0,.47.59,1.06,1.06,0,0,0,.66,0,2.81,2.81,0,0,0,1.79-1.56,8,8,0,0,0,.61-2.37c.52-3.29,1-6.59,1.55-9.89a18.81,18.81,0,0,0-.65,6.88,10.52,10.52,0,0,0,2.81,6.22,2.1,2.1,0,0,0,1,.65c1,.19,1.72-.84,2.12-1.75a24.49,24.49,0,0,0,2.06-11.23,18.74,18.74,0,0,0,2,11,3,3,0,0,0,.65.88,2.88,2.88,0,0,0,1.81.44,2.6,2.6,0,0,0,1.74-.38,2.44,2.44,0,0,0,.7-1.2,25.89,25.89,0,0,0,1.23-10.23,44.92,44.92,0,0,0,2.26,11,3.4,3.4,0,0,0,1.06,1.78,2.42,2.42,0,0,0,3.16-.76,6.34,6.34,0,0,0,1-3.41c.15-1.58-.51-3.22-.06-4.74C587,233.74,559.76,240.31,556.59,242.13Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-28)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M673.41,351.85c-1.65.75-3.61,2.11-3.15,3.86.36,1.36,2.06,1.91,3.45,1.7s2.66-.92,4-1.16a1.77,1.77,0,0,1,1.56.28,1.81,1.81,0,0,1,.43.94c.46,2.43-.84,4.83-2.34,6.8s-3.26,3.83-4,6.19c1.78.9,3.93-.19,5.36-1.58s2.59-3.14,4.38-4l-4.6,8.2c-.42.74-.82,1.73-.27,2.38.74.87,2.13.08,2.93-.73a53,53,0,0,0,6.38-7.86,26,26,0,0,0-2.59,9c1.39.15,2.38-1.24,3.06-2.46l4-7.27a14.8,14.8,0,0,1-1.61,6.46c2.09-.45,3.09-2.77,3.77-4.79,1.88-5.56,3.78-11.28,3.53-17.15-.05-1.28-.3-2.73-1.38-3.43a4.2,4.2,0,0,0-2.28-.48C686.22,346.64,680.52,348.61,673.41,351.85Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-29)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M682.79,339.09a4.64,4.64,0,0,1,1.12-2.36,5,5,0,0,1,3-1l7.66-.88c1.91-.22,4.26-.24,5.3,1.39a4.87,4.87,0,0,1,.46,3,33.67,33.67,0,0,1-1.43,7.64c-.21.65-12.91,1.94-14.06,1.65C680.47,347.36,681.74,343.36,682.79,339.09Z",
    transform: "translate(0)",
    fill: "#2c7be5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M682.79,339.09a4.64,4.64,0,0,1,1.12-2.36,5,5,0,0,1,3-1l7.66-.88c1.91-.22,4.26-.24,5.3,1.39a4.87,4.87,0,0,1,.46,3,33.67,33.67,0,0,1-1.43,7.64c-.21.65-12.91,1.94-14.06,1.65C680.47,347.36,681.74,343.36,682.79,339.09Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-30)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "604.44 452.22 581.1 530.78 602.2 530.78 646.14 452.22 604.44 452.22",
    fill: "#2c7be5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "707.02 452.22 730.37 530.78 709.27 530.78 665.32 452.22 707.02 452.22",
    fill: "#2c7be5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M601.05,547.35c-2,.51-4.12,1-6.09.41S591.35,545,592.1,543c-4.76,1.25-9.17,3.64-13.93,4.89-7.8,2.06-16,1-24-.12a20.53,20.53,0,0,1,10.07-13c5-2.68,10.81-3.16,16.45-3.58l10.83-.81c2.17-.16,6.86-1.48,8.75.06S602.31,547,601.05,547.35Z",
    transform: "translate(0)",
    fill: "#2c7be5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M731,547.35c-2,.51-4.13,1-6.1.41S721.26,545,722,543c-4.77,1.25-9.18,3.64-13.94,4.89-7.8,2.06-16,1-24-.12a20.51,20.51,0,0,1,10.08-13c5-2.68,10.8-3.16,16.44-3.58l10.77-.8c2.18-.16,6.87-1.48,8.75.06S732.18,547,731,547.35Z",
    transform: "translate(0)",
    fill: "#2c7be5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "604.44 452.22 581.1 530.78 602.2 530.78 646.14 452.22 604.44 452.22",
    fill: "url(#linear-gradient-31)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "707.02 452.22 730.37 530.78 709.27 530.78 665.32 452.22 707.02 452.22",
    fill: "url(#linear-gradient-32)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M601.05,547.35c-2,.51-4.12,1-6.09.41S591.35,545,592.1,543c-4.76,1.25-9.17,3.64-13.93,4.89-7.8,2.06-16,1-24-.12a20.53,20.53,0,0,1,10.07-13c5-2.68,10.81-3.16,16.45-3.58l10.83-.81c2.17-.16,6.86-1.48,8.75.06S602.31,547,601.05,547.35Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-33)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M731,547.35c-2,.51-4.13,1-6.1.41S721.26,545,722,543c-4.77,1.25-9.18,3.64-13.94,4.89-7.8,2.06-16,1-24-.12a20.51,20.51,0,0,1,10.08-13c5-2.68,10.8-3.16,16.44-3.58l10.77-.8c2.18-.16,6.87-1.48,8.75.06S732.18,547,731,547.35Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-34)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesAndFolder);
export default __webpack_public_path__ + "static/media/files-and-folder.c460d59f7c3c08d09e7191ca531cf8b2.svg";
export { ForwardRef as ReactComponent };